import { render, staticRenderFns } from "./AssignedDealers.vue?vue&type=template&id=8e87d082&scoped=true"
import script from "./AssignedDealers.vue?vue&type=script&lang=js"
export * from "./AssignedDealers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e87d082",
  null
  
)

export default component.exports